import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../config.service';
import { MaterialCatalogueListItemQuery } from '../../models/material-catalogue/material-catalogue-list-item-query.model';
import { buildQueryString } from '../query-bulider.service';
import { PagedResult } from '../../models/paged-result.model';
import { TaskResultGeneric } from '../../models/task-result-generic';
import { MaterialCatalogueListItem } from '../../models/client-models';

const MATERIALCATALOGUE_ENDPOINT = 'materialcatalogue';

@Injectable({
  providedIn: 'root',
})
export class MaterialCatalogueBackendService {
  constructor(private http: HttpClient) {}

  /**
   * Get material catalogue list form backend with paging and filter.
   *
   * @param materialParams
   */
  public getMaterialCatalogue(materialParams: MaterialCatalogueListItemQuery) {
    const query = buildQueryString(materialParams);
    return this.http.get<
      TaskResultGeneric<PagedResult<MaterialCatalogueListItem>>
    >(AppConfig.settings.backend.url + MATERIALCATALOGUE_ENDPOINT + query);
  }
}
